import React from "react";

const mainStyles = {
  position: "fixed",
  inset: "0",
  background: "rgba(0, 0, 0, 0.5)",
};

const messagebox = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "300px",
  margin: "0px auto",
};
export default function Message(props) {
  return (
    <div style={mainStyles}>
      <div style={messagebox}>
        <p className="text-center">{props.message}</p>
        <button
          className="btn btn-sm btn-primary float-right "
          onClick={() => {
            props.hideMsgPopup();
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}
